import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ChevronLeft, MessageCircle, UserPlus } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import api from "../lib/api.js";

function relTime(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
}

export default function Messages() {
  const nav = useNavigate();
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    api.get("/messages/conversations").then((r) => setConversations(r.data));
  }, []);

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-10">
        <div className="flex items-center justify-between">
          <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="messages-back">
            <ChevronLeft size={16} /> Back
          </button>
          <Link to="/friends" data-testid="messages-add-friend" className="text-xs text-[#2fbf71] font-semibold inline-flex items-center gap-1">
            <UserPlus size={14} /> Add Friend
          </Link>
        </div>
        <h1 className="ps-heading text-3xl font-bold mt-4">Messages</h1>
        <p className="text-slate-400 text-sm">Direct messages with your Posture Steps friends.</p>

        {conversations.length === 0 ? (
          <div className="mt-16 text-center text-slate-500">
            <MessageCircle size={28} className="mx-auto opacity-50" />
            <div className="mt-3 text-sm">No conversations yet.</div>
            <Link to="/friends" className="ps-button-primary inline-block mt-5 text-sm py-2 px-5">Add a Friend</Link>
          </div>
        ) : (
          <div className="mt-6 space-y-2">
            {conversations.map((c) => (
              <Link
                key={c.friend.id}
                to={`/messages/${c.friend.id}`}
                data-testid={`conv-${c.friend.id}`}
                className="ps-card p-4 flex items-center gap-3"
              >
                <div className="relative">
                  <div className="w-12 h-12 rounded-full bg-[#142534] border border-[#1a2f40] flex items-center justify-center font-bold">
                    {c.friend.name?.[0]}
                  </div>
                  {c.unread > 0 && (
                    <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#EF4444] text-white text-[10px] font-bold flex items-center justify-center">
                      {c.unread > 9 ? "9+" : c.unread}
                    </span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-baseline justify-between gap-2">
                    <div className={`font-semibold truncate ${c.unread > 0 ? "text-white" : ""}`}>{c.friend.name}</div>
                    <div className="text-[10px] text-slate-500 shrink-0">{relTime(c.last_message?.created_at)}</div>
                  </div>
                  <div className={`text-xs truncate ${c.unread > 0 ? "text-white" : "text-slate-400"}`}>
                    {c.last_message?.text || "Say hi 👋"}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </PhoneFrame>
  );
}
